import React from "react"
import FactArea from '../../components/fact-area/fact-area-3'

const HeroAreaTwo = () => {
  return (
    <section className="banner-area banner-style-two position-relative">
      <div className="banner__background-wrap">
        <div
          className="background"
          style={{ backgroundImage: "url(/assets/img/bg/collection-grid.png" }}
        ></div>
      </div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10 col-lg-9">
            <div
              className="banner__content-two"
              data-anime="opacity:[0, 1]; translateY:[24, 0]; onview: true; delay: 100;"
            >
              

              <img
                className="top-right"
                src="/assets/img/objects/x.png"
                width="24"
                alt="object"
                style={{top:'20%',right:'-20%'}}
                data-anime="opacity:[0, 1]; scale:[0, 1]; onview: true; delay: 420;"
              />

              <img
                className="left-align"
                src="/assets/img/objects/circle-01.png"
                width="16"
                alt="object"
                style={{top:'16%',left:'-16%'}}
                data-anime="opacity:[0, 1]; scale:[0, 1]; onview: true; delay: 420;"
              />

              

              <img
                className="bottom-right"
                src="/assets/img/objects/circle-03.png"
                width="24"
                alt="object"
                style={{bottom:'-16%',right:'16%'}}
                data-anime="opacity:[0, 1]; scale:[0, 1]; onview: true; delay: 440;"
              />

              {/* <h2 className="title">A growing network of DeFi Apps</h2> */}
              <p className="desc">
              The primary utility for Panther AI is building a fun DeFi community <br/> to spread awareness of AI Technology. 
              </p>

              <div className="about__facts-list">
                  <div className="about__fact-item">
                    <h3 className="count tg-text-gradient">500 M</h3>
                    <p>
                      TOTAL SUPPLY
                    </p>
                  </div>
                </div>

                <FactArea />


              {/* <a
                href="#"
                data-target="#collection"
                className="banner__btn btn gradient-btn gradient-btn-2 scroll-to-target"
              >
                <span>Join Now</span>
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HeroAreaTwo
